import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=0e4f69a9"
import script from "./TeamMember.vue?vue&type=script&lang=ts"
export * from "./TeamMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports